import { useEffect, useState, useContext } from 'react';
import intersectionWith from 'lodash.intersectionwith';

import discountBanners from '../data/discounts.json';
import { StoreContext } from '../store';

export const useDiscounts = () => {
  const {
    applyDiscount,
    store: { checkout },
  } = useContext(StoreContext);

  const [state, setState] = useState({
    checked: false,
    type: '1',
    banner: null,
  });

  const { checked, type, banner } = state;

  useEffect(() => {
    if (checked) return;
    const searchParams = new URLSearchParams(window.location.search);
    const params = [];
    for (const [key, value] of searchParams) {
      params.push({ key, value });
    }
    const discountBanner = intersectionWith(
      discountBanners,
      params,
      (a, b) => a.uid === b.key,
    )?.[0];
    if (discountBanner) {
      window.sessionStorage.setItem('bannerDiscountCode', discountBanner.coupon_code);
    }
    if (checkout) {
      if (!discountBanner) return setState(prevState => ({ ...prevState, checked: true }));
      const type = searchParams.get(discountBanner.uid);
      if (type === '2') {
        applyDiscount(checkout.id, discountBanner.coupon_code);
      }
      setState({
        checked: true,
        type,
        banner: discountBanner,
      });
    }
  }, [checkout, checked]);

  return [banner, type];
};
